Pixlee.module('MosaicV2App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            widgetHeaderRegion: '#widget_header_region',
            interactiveRegion: '#interactive_region',
            frame: '.mosaic_frame'
        },
        ui: {
            loadMore: '.load_more',
            mosaicControl: '#mosaic_control'
        },
        collectionEvents: {
            'sync': 'collectionChange',
            'reset': 'collectionChange'
        },
        events: {
            'click .load_more': 'loadMore'
        },
        initialize: function() {
            this.firstLoad = true;
            this.displayOptions = App.request('get:display:options');
            this.infiniteLoadOption = this.displayOptions.get('infiniteLoadMore');
            // Slight debounce for when 'sync' and 'reset' are triggered at the same time
            this.debounceReloadIsotope = _.debounce(function() {
                this.triggerMethod('reload:isotope');
            }.bind(this), 200, false);
        },
        onShow: function() {
            this.triggerMethod('check:design:editor');
            // Check if 'infiniteLoadMore' display option is enabled
            if (!_.isFalsy(this.infiniteLoadOption)) {
                this.ui.loadMore.addClass('loading').hide();
                this.waitForLoadMoreRequest();
            }
        },
        onCheckDesignEditor: function() {
            var href = window.location.href;
            if (href.indexOf('design_editor_device=mobile') > -1) {
                this.$el.addClass('mosaic_design_editor');
            }
        },
        collectionChange: function() {
            // firstLoad may be overkill but it will make the widget as fast as possible
            if (this.firstLoad) {
                this.firstLoad = false;
                this.triggerMethod('reload:isotope');
            } else {
                this.debounceReloadIsotope();
            }
        },
        onInitIsotope: function() {
            this.grid = $('.clearfix').isotope({
                layoutMode: 'packery',
                itemSelector: '.photo_block',
                transitionDuration: 0
            });
        },
        onReloadIsotope: function() {
            var loadMore = this.checkMosaicLoadMore();
            if (!_.isFalsy(this.grid)) {
                this.grid.imagesLoaded().progress(function() {
                    this.grid.isotope('reloadItems');
                    this.triggerMethod('init:isotope');
                }.bind(this));
            }
            if (loadMore) {
                this.ui.loadMore.show();
            } else {
                this.ui.loadMore.hide();
            }
        },
        loadMore: function() {
            var loadMore = this.checkMosaicLoadMore();
            if (loadMore) {
                this.ui.loadMore.addClass('loading');
                this.collection.nextPage({
                    success: function() {
                        this.ui.loadMore.removeClass('loading');
                        App.commands.execute('load:more', this.collection.pluck('album_photo_id'));
                        loadMore = this.checkMosaicLoadMore();
                        if (!loadMore) {
                            this.ui.loadMore.hide();
                        }
                    }.bind(this)
                });
            }
        },
        infiniteLoadMore: function() {
            if (this.collection.next) {
                this.ui.loadMore.show();
                this.collection.nextPage({
                    success: function() {
                        if (this.finishedFirstLoad) {
                            App.commands.execute('load:more', this.collection.pluck('album_photo_id'));
                        }
                        this.finishedFirstLoad = true;
                        this.ui.loadMore.hide();
                        this.is_loading = false;
                    }.bind(this)
                });
            } else {
                this.is_loading = false;
            }
        },
        waitForLoadMoreRequest: function() {
            var receiveMessage = _.debounce(function(event) {
                try {
                    var eventData = JSON.parse(event.data);
                    if (eventData.name === 'pixlee:infinite:load:more' && !this.is_loading) {
                        this.is_loading = true;
                        this.infiniteLoadMore();
                    }
                } catch (e) {
                    return;
                }
            }.bind(this), 500, false);
            window.addEventListener('message', receiveMessage, false);
        },
        checkMosaicLoadMore: function() {
            // Check if there's a next page for 'mosaic infinite load'
            var infiniteLoadNextPage = !_.isFalsy(this.infiniteLoadOption) && this.collection.next;

            // Check if there's a next page for 'perfact mosaic'
            var queueModel = this.collection.findWhere({
                'queueModel': true
            });
            // If there is a queue model, the collection is empty but there still could be a next page
            var perfectMosaicNextPage = _.isFalsy(this.infiniteLoadOption) && (this.collection.next || !queueModel);

            return infiniteLoadNextPage || perfectMosaicNextPage;
        }
    });

    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);

    Show.PhotoView = App.Views.ItemView.extend({
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        modelEvents: {
            'voted': 'onVotePhoto'
        },
        getTemplate: function() {
            var elementSize = this.model.get('elementSize');
            // If the widget is infinite load, photo sizes are completely random
            if (this.options.isInfiniteLoad) {
                if (_.random(0, 1)) {
                    elementSize = 'large';
                } else {
                    elementSize = 'small';
                }
                this.model.set('elementSize', elementSize);
            }
            var isLargeTemplate = _.contains(['xl', 'original'], this.options.photoQuality);
            if (isLargeTemplate && elementSize === 'large') {
                return require('../../common/templates/v2/_xl_photo_item.jst.ejs');
            } else {
                return require('../../common/templates/v2/_photo_item.jst.ejs');
            }
        },
        onShow: function() {
            this.triggerMethod('watch:top:change');
            this.triggerMethod('set:element:size:class');
        },
        onWatchTopChange: function() {
            var collection = this.model.collection;
            var index = collection.indexOf(this.model);
            var absoluteIndex = index - this.options.initialLength;
            var animationOffset = absoluteIndex > 0 ? (absoluteIndex * 50) : 0;
            var _this = this;
            this.$el.watch({
                properties: 'top,left',
                callback: function(data, i) {
                    setTimeout(function() {
                        if (_this.isIE()) {
                            $(this).addClass('IE_fix');
                        } else {
                            $(this).addClass('fade_in_js');
                        }
                        // run only once - delay to ensure ops have run aren't reset
                        setTimeout(function() {
                            $(this).unwatch(data.id);
                        }.bind(this), 10);
                    }.bind(this), 500 + animationOffset);
                }
            });
        },
        onSetElementSizeClass: function() {
            this.$el.addClass(this.model.get('elementSize'));
        },
        onVotePhoto: function() {
            this.$el.find('.vote_button').addClass('active');
        },
        isIE: function() {
            return (navigator.userAgent.indexOf('MSIE') !== -1) || (!!window.MSInputMethodContext && !!document.documentMode);
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    Show.MosaicCollection = App.Views.CompositeView.extend({
        template: require('./templates/_collection_view.jst.ejs'),
        childViewContainer: '#item_container',
        childView: Show.PhotoView,
        childViewOptions: function() {
            return {
                initialLength: this.initialLength || 0,
                isInfiniteLoad: gon.display_options && gon.display_options.infiniteLoadMore,
                photoQuality: gon.display_options && gon.display_options.photoQuality || 'default'
            };
        },
        events: {
            'click #header_tile_container': 'clickUpload'
        },
        behaviors: function() {
            var behaviorHash = {
                CollectionVote: {}
            };

            // for backwards compatibility with widgets that are already out in the wild
            if (!_.isFalsy(this.options.displayOptions.headerOptions)) {
                behaviorHash.AppendUploaderTiles = {};
                if (this.options.displayOptions.headerOptions.layout === 'tile') {
                    behaviorHash.Upload = {};
                }
            }
            return behaviorHash;

        },
        initialize: function(options) {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };

            //if this isn't infinite load, we wanna run the mosaic calc
            this.runMosaicCalculation = !(gon.display_options && gon.display_options.infiniteLoadMore);
            this.collectionHasSynced = false;

            gon.fresh_images = [];
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            this.safariTimeOut = isSafari ? 100 : 0;
            this.initialLength = 0;
            this.collectionQueue = options.collectionQueue;
            this.triggerMethod('init:mosaic:calculations');
        },
        onShow: function() {
            //if the sync hasn't returned yet we wanna run the calc
            if (this.runMosaicCalculation && this.collectionHasSynced) {
                this.triggerMethod('calculate:perfect:mosaic');
            }

            var calculationBlock = $('#calculation_block');
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            this.calculationBlockWidth = isSafari ? 0 : calculationBlock[0].getBoundingClientRect().width || 0;
            calculationBlock.remove();
            $('#widget').attr('alt', App.altText);
            this.runMosaicCalculation = true; //so load more can work
        },
        onHeaderRendered: function() {
            $('#header_wrapper').css('visibility', 'visible');
        },
        onInitMosaicCalculations: function() {
            // If infinite load completely randomize the mosaic
            if (!this.runMosaicCalculation) {
                //if we overwrite the collection, we need to carry over the reviewSelectionOptions
                var reviewSelectionOptions = this.collection.reviewSelectionOptions;
                this.collection = this.collectionQueue;
                this.collection.reviewSelectionOptions = reviewSelectionOptions;

                this.collection.on('sync', function() {
                    this.initialLength = this.collection.length;
                }.bind(this));
            } else {
                // Otherwise perfect load each mosaic page
                this.collectionQueue.on('sync', function() {
                    if (this.collectionQueue.currentPage === 1) {
                        this.collection.reset();
                    }
                    this.initialLength = this.collection.length;
                    setTimeout(function() {
                        this.safariTimeOut = 0;
                        if (this._isRendered) {
                            this.triggerMethod('calculate:perfect:mosaic');
                            this.runMosaicCalculation = false;
                        }
                        this.collectionHasSynced = true;
                    }.bind(this), this.safariTimeOut);
                }.bind(this));
            }
        },
        onCalculatePerfectMosaic: function() {
            // Calculation Constants
            var itemContainerWidth = $('#item_container').width();

            var viewPortWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            var vw = viewPortWidth / 100;
            var smallPhotoWidth = (24 * vw) - 3;
            smallPhotoWidth = (smallPhotoWidth >= 0) ? smallPhotoWidth : 0;

            // Grab smallPhotoWidth from the max photo width of a small element else default fallback
            smallPhotoWidth = (this.calculationBlockWidth > 1) ? this.calculationBlockWidth : smallPhotoWidth;
            // Initial Calculation
            var totalSmallGridWidth = Math.floor(itemContainerWidth / smallPhotoWidth);
            // Call behavior file 'perfectMosaicHelpers' to kick off calculations
            this.calculatePhotoSizes(totalSmallGridWidth);
        },
        showLoadMore: function() {
            this.$el.find('#mosaic_control').show();
        },
        hideLoadMore: function() {
            this.$el.find('#mosaic_control').hide();
        },
        clickUpload: function() {
            // since upload button is small on mobile inside a header tile,
            // make the entire tiheader tile clickable to bring up the uploader
            var data = {
                name: 'pixlee:show:uploader',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    widgetId: window.location.href,
                    // For accessiblity purposes: tracking whether user is using keyboard/mouse
                    // Used to keep track of using-keyboard or using-mouse for uploader
                    // usingKeyboard will always be false when using mobile
                    usingKeyboard: false
                }
            };

            window.parent.postMessage(JSON.stringify(data), '*');
        }
    });
    Show.MosaicCollection.include(['headerHelpers', 'perfectMosaicHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);

    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});
